export default "__VITE_ASSET__BBj9ETOf__"